"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.unscopables.flat.js");

require("core-js/modules/es.string.trim.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePushEvent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _resolveFuncValues = require("./resolveFuncValues");

var _debounceAccumulate = require("./debounceAccumulate");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_DEBOUNCE_DELAY = 5000;

var makePushEvent = function makePushEvent(makePostAnalytics) {
  return function (_ref) {
    var apiUrl = _ref.apiUrl,
        _ref$baseProps = _ref.baseProps,
        baseProps = _ref$baseProps === void 0 ? {} : _ref$baseProps,
        _ref$debounceDelay = _ref.debounceDelay,
        debounceDelay = _ref$debounceDelay === void 0 ? DEFAULT_DEBOUNCE_DELAY : _ref$debounceDelay,
        handlePartialFailure = _ref.handlePartialFailure;

    if ((0, _typeof2["default"])(baseProps) !== 'object' || baseProps === null) {
      throw new Error('baseProps must be an object');
    }

    var postAnalytics = makePostAnalytics(apiUrl, handlePartialFailure);
    var postAnalyticsDebounced = (0, _debounceAccumulate.debounceAccumalate)({
      fn: function fn(events) {
        return postAnalytics(events.flat());
      },
      delay: debounceDelay
    });
    return function (eventOrEvents) {
      var eventsArr = [].concat(eventOrEvents);
      var events = eventsArr.map(function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            category = _ref2.category,
            _ref2$data = _ref2.data,
            data = _ref2$data === void 0 ? {} : _ref2$data;

        if (typeof category !== 'string' || !category.trim()) {
          throw new Error('category string is required');
        }

        if ((0, _typeof2["default"])(data) !== 'object' || data === null) {
          throw new Error('data must be an object');
        }

        return {
          eventName: category,
          eventData: _objectSpread(_objectSpread({}, (0, _resolveFuncValues.resolveFuncValues)(baseProps)), (0, _resolveFuncValues.resolveFuncValues)(data))
        };
      });
      return postAnalyticsDebounced(events);
    };
  };
};

exports.makePushEvent = makePushEvent;